module.exports = __webpack_public_path__ + "static/media/santa-isabel.63dab39a.svg";